import React from "react";
import "./Fold.scss";
import foldImage from "./images/fold-image.webp";
import andImage from "./images/and.svg";
import cheersImage from "./images/cheers.svg";
function Fold() {
  return (
    <div className="flex flex-align-center relative fold">
      <div className="col-12 hidden-lg hidden-xl bg-secondary text-center p-inline-1 p-block-2 mobile-header">
          <div className="flex flex-align-center flex-justify-center full-width">
            <h6>ИННА</h6>
            <h6 className="p-inline-1">и</h6>
            <h6>СТОЯН</h6>
          </div>
      </div>
      <div className="col-5 col-12-xs col-12-sm col-12-md animation-slide-fade-in-left animation-delay-3s animation-duration-1s opacity-0"> 
        <img
          className="fold-image"
          width={"100%"}
          height={"auto"}
          src={foldImage}
          alt="Maria and Krasimir"
        ></img>
      </div>
      <div className="relative col-7 col-12-xs col-12-sm col-12-md text-center p-2 p-top-8-md p-top-8-sm p-top-4-xs">
        <div className="m-bottom-1 m-top-2">Скъпи гости,</div>
        <div className="m-bottom-4">ние,</div>
        <h1 className="names-fontsize">ИННА</h1>
        <div className="col-6 m-inline-auto">
            <img
              className="fold-and-image"
              width={"100%"}
              height={"auto"}
              src={andImage}
              alt="and"
            >
        </img>
        </div>
        <h1 className="names-fontsize">СТОЯН</h1>
        <div className="col-9 col-12-xs col-12-sm col-12-md m-inline-auto m-top-4 p-inline-4-sm">
          с огромна радост ви каним на <br className="hidden-xs hidden-sm"/> най-вълнуващото събитие в живота ни - нашата сватба! <br className="m-top-2-xs"/> Ще се радваме в този важен ден да бъдете до нас!
        </div>
        <h2 className="m-top-3 m-bottom-1 font-body custom-date-font-size"><span className="font-body">06</span> Юни, <span className="font-body">2026</span></h2>
        <div className="m-bottom-4">с. Аспарухово</div>
      </div>
      <img
        className="fold-cheers-image"
        width={"100%"}
        height={"auto"}
        src={cheersImage}
        alt="cheers"
      >
        </img>
    </div>
  );
}

export default Fold;
